import { Channel, Program } from '../types'
import { formatDate, getResource } from '../utils'
import { ProgramImage } from './program-drawer-components'
import { RecordDot, RecordDots } from './program-drawer-components/record-dots'

export const ProgramCard = ({
  program,
  channel,
  recordingType,
  onProgramClick,
  displayNow,
  hiddeChannelTitle = false,
}: {
  program: Program
  channel: Channel | undefined
  recordingType: string
  onProgramClick: (
    id: number | undefined,
    channel: Channel | undefined,
    date: string | undefined
  ) => void
  displayNow?: boolean
  hiddeChannelTitle?: boolean
}) => {
  const imageSource = `https://cdn-er-images.online.meo.pt/eemstb/ImageHandler.ashx?progTitle=${program.title}&chCallLetter=${channel?.callLetter}&profile=16_9&appSource=GuiaTV&width=300&stb=retina2x`
  const formatedTime = ` ${program.start.time} - ${program.end.time}`
  return (
    <button
      className="program-card-wrapper"
      type="button"
      onClick={() => {
        onProgramClick(
          program.id,
          channel,
          program.start.day.split('/').reverse().join('-')
        )
      }}
    >
      {displayNow && (
        <div className="program-card-now-indicator">
          <span>{getResource('ProgramCard.Now')}</span>
        </div>
      )}
      <div
        key={program.id}
        className={`program-card ${displayNow ? 'program-card-now' : ''} `}
        id={String(program.id)}
      >
        {displayNow ? (
          <ProgramImage
            availableOnMeoGo={channel?.MEOGo.isAvailable || false}
            title={program.title}
            titleId={program.titleId}
            callLetter={channel?.callLetter || ''}
            friendlyUrlName={channel?.friendlyUrlName || ''}
            startDate={program.start.date}
            endDate={program.end.date}
            programId={program.id}
          />
        ) : (
          <img src={imageSource} alt={program.title} />
        )}
        <div className="program-card-container">
          <div>
            <h2 className="program-title no-translate">
              {program.title} {recordingType === 'everyday' && <RecordDots />}
              {recordingType === 'once' && <RecordDot />}
            </h2>
            {!hiddeChannelTitle && (
              <p className="channel-title no-translate">{channel?.title}</p>
            )}
            <p>
              {formatDate(program.start.date)}, {formatedTime}
            </p>
            <div className="program-synopsis">{program.synopsis}</div>
          </div>
          <span
            className={`btn-text ${
              displayNow ? 'btn-color-4' : 'btn-color-1'
            } program-card-button`}
          >
            {getResource('ProgramCard.SeeMore')}
          </span>
        </div>
      </div>
    </button>
  )
}
